import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'ticketing',
} as const satisfies Location
